interface BrandProps {
  size?: "sm" | "md" | "lg";
}

export function Brand({ size = "sm" }: BrandProps) {
  const fontSize = size === "lg" ? "var(--acx-fs-md)" : size === "md" ? "var(--acx-fs-sm)" : "var(--acx-fs-xs)";
  const markSize = size === "lg" ? 72 : size === "md" ? 52 : 40;
  return (
    <span className="acx__brand" style={{ fontSize }}>
      <span
        className="acx__brand-mark"
        style={{ width: markSize, height: markSize }}
        aria-hidden
      >
        <img src="/brand-mark.png" alt="" className="acx__brand-mark-img" />
      </span>
      <span className="acx__brand-text">Acruxsoft</span>
    </span>
  );
}
